module.exports = __webpack_public_path__ + "img/water_droplet_0.fc713f73.svg";